import React from "react";
import { createPortal } from "react-dom";
import i18n from "i18next";
import { interactiveExampleUrl } from "./interactiveItemService";
import "./_interactiveItem.scss";

/* eslint-disable react/prop-types */

/**
 * Örnek önizleme penceresi — "bu ne boka benzeyecek".
 *
 * ──────────────────────────────────────────────────────────────────────────
 * NEDEN RESİM DEĞİL, OYNANABİLİR
 * ──────────────────────────────────────────────────────────────────────────
 * Gösterilen şey gerçekten üretilmiş bir widget: kartı çevirebilir, eşleştirme
 * yapabilir, çarkı çevirebilir. Statik bir ekran görüntüsü "nasıl görünüyor"
 * sorusunu yarım cevaplar, "nasıl oynanıyor" sorusunu hiç cevaplamaz — ve bir
 * aktivitede asıl merak edilen ikincisi.
 *
 * Elle çizilmiş bir maket de olabilirdi; olmadı. Maket idealize edilmiş bir
 * resim gösterir, modelin gerçekte ürettiğini değil. Buradaki örnek kötü
 * görünüyorsa üretim de kötü görünecek demektir: bu bir kusur değil, bilgi.
 *
 * ──────────────────────────────────────────────────────────────────────────
 * ÖRNEK OLDUĞU HER YERDE YAZAR
 * ──────────────────────────────────────────────────────────────────────────
 * İçerik bilerek yer tutucu ("Örnek Başlık 1", "Seçenek A") ve dosyanın kendi
 * içinde de bir "Örnek" şeridi var. Yazarın bunu kendi eğitiminin bir parçası
 * sanması, önizlemenin işe yaramasından daha pahalıya mal olur.
 */
export default function InteractiveExample({ type, onClose }) {
  if (!type) return null;

  return createPortal(
    <div className="ii-editor" onClick={onClose}>
      <div className="ii-editor__panel ii-editor__panel--wide" onClick={(e) => e.stopPropagation()}>
        <header className="ii-editor__head">
          <div>
            <h2>
              {type.label}
              <span className="ii-tag ii-tag--example">
                {i18n.t("InteractiveItem.ExampleTag", { defaultValue: "örnek" })}
              </span>
            </h2>
            <p>
              {i18n.t("InteractiveItem.ExampleHint", {
                defaultValue:
                  "Gerçekten üretilmiş bir çıktı — deneyebilirsin. İçerik yer tutucudur, senin anlatımınla üretilecek olan budur.",
              })}
            </p>
          </div>
          <button type="button" className="ii-editor__x" onClick={onClose}>
            ✕
          </button>
        </header>

        <iframe
          className="ii-example__frame"
          src={interactiveExampleUrl(type.id)}
          title={type.label}
          sandbox="allow-scripts"
        />

        <footer className="ii-editor__foot">
          <span className="ii-example__meta">
            {type.sizeHint}
            {type.scored
              ? ` · ${i18n.t("InteractiveItem.Scored", { defaultValue: "puanlı" })}`
              : ` · ${i18n.t("InteractiveItem.Unscored", { defaultValue: "puansız" })}`}
          </span>
          <button type="button" className="ii-btn" onClick={onClose}>
            {i18n.t("close") || "Kapat"}
          </button>
        </footer>
      </div>
    </div>,
    document.body
  );
}
